import { ReactNode, cloneElement, isValidElement } from 'react'

import { isShowingMplus } from 'shared/constants'

import s from './styles.module.scss'

export const MonthTermInstallment = {
  firstMeridian: {
    priceOfTicket: 15_000,
  },
  secondMeridian: {
    priceOfTicket: 100_000,
  },
}

interface Props {
  price?: string
  isMplus?: boolean
  mplusPayment?: ReactNode
  regularPayment?: ReactNode
  mInstalmentPayment?: ReactNode
}

export const PaymentWithTerm = ({
  price,
  isMplus,
  mplusPayment,
  regularPayment,
  mInstalmentPayment,
}: Props) => {
  const parsedPrice = Number(price || '0')

  if (
    isMplus &&
    isShowingMplus &&
    parsedPrice < MonthTermInstallment.firstMeridian.priceOfTicket
  ) {
    if (!isValidElement(mplusPayment)) return null

    return cloneElement(mplusPayment, {}, regularPayment)
  }

  if (parsedPrice >= MonthTermInstallment.firstMeridian.priceOfTicket) {
    if (!isValidElement(mInstalmentPayment)) return null

    return cloneElement(mInstalmentPayment, {}, regularPayment)
  }

  return <div className={s.wrapper}>{regularPayment}</div>
}
